<template>
  <!-- 添加ig物品弹窗 -->
  <div>
    <div v-if="!buttonFlag">
      <div v-if="selectedPrize" class="prize-item" @click="visiblePrize = true">
        <img :src="selectedPrize.image" alt />
        <p>
          <span>{{ selectedPrize.name }}</span>
        </p>
        <p>
          <span>{{ selectedPrize.second_name }}</span>
        </p>
        <p>
          <span :style="`color: ${getRankColor(selectedPrize.rank)};`">{{
              getRank(selectedPrize.rank)
          }}</span>
          <span class="price">${{ selectedPrize.price }}</span>
        </p>
      </div>
      <div v-else class="add-prize" @click="visiblePrize = true">
        <i class="el-icon-plus"></i>
        <p>选择奖品</p>
      </div>
    </div>
    <el-button type="success" @click="visiblePrize = true" v-else>IG商品</el-button>
    <!-- 奖品列表 -->
    <el-dialog append-to-body :visible.sync="visiblePrize" title="奖品列表" :close-on-click-modal="false" width="930px">
      <el-row style="margin-bottom: 20px">
        <el-input style="width: 200px; margin-right: 20px" placeholder="奖品名称搜索" v-model="query.name"></el-input>
        <el-button type="primary" @click="getPrize(1)">搜索</el-button>
      </el-row>
      <div class="prize-list-wrap" v-loading="loadingPrize">
        <ul class="prize-list">
          <li class="prize-item" v-for="item in prizeList" :key="item.id">
            <i class="el-icon-plus" title="添加" @click="handleAddPrize(item)"></i>
            <img :src="item.image" alt />
            <p>
              <span>{{ item.name }}</span>
            </p>
            <p>
              <span>{{ item.second_name }}</span>
            </p>
            <p>
              <span v-if="item.darkgoldenrod === 1">暗金：普通"</span>
              <span v-if="item.darkgoldenrod === 2">暗金：StatTrak™"</span>
              <span v-if="item.darkgoldenrod === 3">暗金：★StatTrak™"</span>
              <span v-if="item.darkgoldenrod === 4">暗金：★"</span>
              <span v-if="item.darkgoldenrod === 5">暗金：纪念品"</span>
            </p>
            <p>
              <span :style="`color: ${getRankColor(item.rank)};`">{{
                  getRank(item.rank)
              }}</span>
              <span class="price">${{ item.price }}</span>
            </p>
            <p style="text-align: center">
              数量：{{ item.number - item.sold_number }}
            </p>
          </li>
        </ul>
        <ul class="pagination" v-if="prizeListMeta" title="首页">
          <li :class="`home-page ${prizeListMeta.current_page === 1 ? 'active' : ''
          }`" @click="handleIGPageChange(1)">
            首页
          </li>
          <li v-if="prizeListMeta.current_page != 1" class="item-page previous-page" @click="handleIGPageChange(2)"
            title="上一页">
            <i class="el-icon-arrow-left"></i>
          </li>
          <li v-if="prizeListMeta.total_pages === 1" class="item-page next-page" @click="handleIGPageChange(3)"
            title="下一页">
            <i class="el-icon-arrow-right"></i>
          </li>
          <span> 第{{ prizeListMeta.current_page }}页 </span>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getData, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import rank from '@/utils/ranks'
import quality from '@/utils/quality'
import { Button } from 'element-ui'

export default {
  props: {
    value: {//数据
      type: Object,
      default: undefined
    },
    prizeInfo: {//奖品信息
      type: Object,
      default: undefined
    },
    typeNum: {//弹窗类型
      type: Number,
      default: 1
    },
    buttonFlag: {//是否显示状态为按钮
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      visiblePrize: false,//奖品列表显示标志
      loading: false,//加载动画
      loadingPrize: false,//加载物品列表的动画
      buttonLoading: false,//按钮加载动画
      taskData: undefined,//任务列表
      prizeList: undefined,//奖品列表
      query: {//奖品搜索
        page: 1,
        type: 1,//1是csgo 2是dota
        name: undefined,
      },
      selectedPrize: undefined,//选择的奖品信息
      prizeListMeta: undefined,//奖品列表的底部分页
      staticData: {
        rank: rank,
        quality: quality,
      },
      taskRules: {//任务表单验证
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogInfo: {
      get() {
        return this.prizeInfo
      },
      set() {
      }
    },
    dialogType: {
      get() {
        return this.typeNum
      },
      set() {
      }
    },
  },
  watch: {
    dialogInfo: {
      handler(newVal, oldVal) {
        this.selectedPrize = newVal
      },
      immediate: true,
      deep: true
    },
    visiblePrize(val) {
      //监听物品列表弹窗显示
      if (val) {
        // 初始化数据后再获取数据列表
        this.query.page = 1
        this.query.name = undefined
        this.prizeListMeta = undefined
        this.getPrize()
      }
    }
  },
  created() {
  },
  methods: {
    handleAddPrize(rowInfo) {
      //选择奖品并赋值
      this.selectedPrize = rowInfo
      this.visiblePrize = false
      this.$emit("selectedData", rowInfo)
    },
    getPrize(num) {
      if (num === 1) {
        this.query.page = 1
      }
      //查询奖品
      this.loadingPrize = true
      let params = this.query
      getData(`igPrize`, params)
        .then(res => {
          this.prizeList = res.data
          this.prizeListMeta = {
            current_page: res.meta.current_page, //当前页标
            total_pages: res.meta.is_more, //是否有下一页 1代表有 0代表无
          }
        })
        .finally(() => {
          this.loadingPrize = false
        })
    },
    handleIGPageChange(num) {
      //切换饰品列表的分页
      switch (num) {
        case 1:
          this.query.page = 1;//首页
          break;
        case 2:
          this.query.page = this.query.page - 1;//上一页
          break;
        case 3:
          this.query.page = this.query.page + 1;//下一页
          break;
      }
      this.getPrize()//搜索数据
    },
    getRank(rank) {
      for (let item of this.staticData.rank) {
        if (item.level === rank) {
          return item.text
        }
      }
    },
    getRankColor(rank) {
      for (let item of this.staticData.rank) {
        if (item.level === rank) {
          return item.color
        }
      }
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
.prize-item {
  margin-right: 10px;
}

//IG底部分夜样式
.pagination {
  display: flex;
  align-items: center;

  li {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
    background-color: #f4f4f5;
    color: #606266;
    border-radius: 2px;

    &:hover {
      background-color: #409eff;
      color: #fff;
    }
  }

  .home-page {
    min-width: 40px;
    height: 30px;
    background-color: #f4f4f5;
    color: #606266;
    border-radius: 2px;
    height: 30px;
  }

  .item-page {
    min-width: 30px;
    height: 30px;
  }

  .active {
    background-color: #409eff;
    color: #fff;
  }
}
</style>